export default "__VITE_ASSET__OSo9X$Ye__"